import axios from 'axios';
import Cookies from 'js-cookie'
import {useRouter } from 'vue-router';

const router = useRouter();

const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}/api`,
  withCredentials: true,
});

apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const response = await apiClient.post('/token/refresh-token');
        const newAccessToken = response.data.accessToken;

        Cookies.set('authToken', newAccessToken);
        
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

        return axios(originalRequest);
      } catch (err) {
        console.error('Error refreshing token:', err);

        try {
          await apiClient.post('/logout/close');
        } catch (logoutError) {
          console.error('Error during logout:', logoutError);
        }
        
        Cookies.remove('authToken');
        Cookies.remove('refreshToken');
      
        router.replace('/');
        window.location.href = '/';
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);


export default apiClient;